export default "__VITE_ASSET__d7c1e515__"